<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Criar Contrato
          </h4>
        </div>
        <div class="modal-body">
          <div v-if="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
          </div>
          <div class="row">
            <div class="col-md-6">
              <money-field
                label="Valor sem desconto" v-model="contractForm.get('amountWithoutDiscount').value"
                :errors="contractForm.get('amountWithoutDiscount').errors"
                @input="contractForm.get('amountWithoutDiscount').validateField()"
              />
            </div>
            <div class="col-md-6">
              <money-field
                label="Valor com desconto" v-model="contractForm.get('amountWithDiscount').value"
                :errors="contractForm.get('amountWithDiscount').errors"
                @input="contractForm.get('amountWithDiscount').validateField()"
              />
            </div>
            <div class="col-md-6 ">
              <ZPopover overlay="overlay" position="right-center">
                <template #target>
                  <label>
                    <span>Data de vencimento</span>
                    <ZIcon icon="question-circle" size="medium" />
                  </label>
                </template>
                <template #content>
                  Vencimento referente a primeira mensalidade do contrato
                </template>
              </ZPopover>
              <date-picker
                v-model="contractForm.get('dueDate').value" :config="datePickerOptions"
                :errors="contractForm.get('dueDate').errors" @input="contractForm.get('dueDate').validateField()"
              />
            </div>
            <div class="col-md-6">
              <input-field
                label="Número de mensalidades" v-model="contractForm.get('installmentsNumber').value"
                :errors="contractForm.get('installmentsNumber').errors"
                @input="contractForm.get('installmentsNumber').validateField()"
                :type="'number'"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="createContract">
              Criar contrato
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { FormGroup } from 'utils/form';
import {
  MoneyField, InputField,
} from 'components/form';
import Permissions from 'mixins/Permissions';
import ContractsService from 'services/ContractsService';
import DatePicker from 'vue-bootstrap-datetimepicker';
import datePickerOptions from 'utils/DatePickerOptions';

export default {
  props: {
    billing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      contractForm: new FormGroup({
        amountWithDiscount: {
          required: true,
        },
        amountWithoutDiscount: {
          required: true,
        },
        dueDate: {
          required: true,
        },
        installmentsNumber: {
          required: true,
          greaterThan: 0,
          lowerThan: 13,
        },
      }),
      errorMessage: null,
      overlay: true,
      datePickerOptions,
    };
  },
  mixins: [Permissions],
  components: {
    DatePicker,
    MoneyField,
    InputField,
  },
  methods: {
    ...mapActions([
      'loadStudentContracts',
    ]),

    createContract() {
      const payload = {
        ...this.contractForm.getRawValue(),
        billing_id: this.billing.id,
      };
      this.$loader.show();
      ContractsService.createContract(payload)
        .then(() => {
          this.loadStudentContracts();
          this.$alert.notifySuccess('Contrato criado');
          this.$emit('close');
        })
        .catch((error) => {
          this.errorMessage = error?.response?.data?.message;
        })
        .finally(() => this.$loader.hide());
    },
  },
};
</script>

<style>
.parcelamento-warning {
  margin-bottom: 5px;
}

.z-icon {
  margin-left: 2px;
  margin-bottom: 1px;
}

body {
  position: unset !important;
}
</style>
